import { filter, mergeMap, map } from 'rxjs/operators';

import { onCompleteAddressActionCreators } from '../../../config/address-lookup.config';
import { lookupAddress } from '../../../features/address-verification/reducers/addressLookup';
import { savePersonalInfo, savePersonalInfoLargeBusiness } from '../../../features/application/reducers/personalInfo';
import { RootEpic } from '../index';

export const savePersonalInfoSmallBusinessEpic: RootEpic = (action$) => {
  return action$.pipe(
    filter(savePersonalInfo.match),
    mergeMap(({ payload }) => {
      return [
        lookupAddress({
          address: payload.address,
          type: 'personal',
        }),
      ];
    }),
  );
};

export const savePersonalInfoLargeBusinessEpic: RootEpic = (action$, state$) => {
  return action$.pipe(
    filter(savePersonalInfoLargeBusiness.match),
    map(() => onCompleteAddressActionCreators.personal(state$.value)),
  );
};
